import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Toast } from "react-bootstrap";
import { useParams, useHistory } from "react-router";
import { FaCartPlus } from 'react-icons/fa';
import { AiFillDelete, AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import { FaExpand, FaCompress } from 'react-icons/fa';  // Import Fullscreen icons

import React from 'react';
import { Helmet } from "react-helmet-async";
import { API, API as api, username } from "../API";
import { toastSuccess, toastWarning } from "../utilis/toast"

import Api from "../Api/Api";
import { isAutheticated } from "./auth/authhelper";
import ToastProduct from "./ToastProduct";
import "./playMovie.css"
import { FiShare2 } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import NavBar from "./Navbar";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const PlayMovie = ({ getCart }) => {
  const location = useLocation();
  const sourceUrl = location.state?.fromUrl;

  // Extract the `videoUrl` query parameter
  const queryParams = new URLSearchParams(location.search);
  const videoUrl = queryParams.get("v");
  const [studioData, setStudioData] = useState(false)
  const [currentProduct, setCurrentProduct] = useState(false)
  const [adVideo, setAdVideo] = useState(false)
  const [toast, setToast] = useState(false)
  const [loading, setLoading] = useState(false)
  const [resumeTime, setResumeTime] = useState(0)
  const [showCart, setShowCart] = useState(false)
  const [channelType, setChannelType] = useState("")

  // Extract the movie ID from the slug (the last part after '-')
  const { showid, slug, category } = useParams();
  const [vediocategoryLogo, setvediocategoryLogo] = useState("");
  const [categoryId, setCategoryId] = useState(null);
  const [channelID, setChannelID] = useState(null);
  const [subchannellID, setSubChannelID] = useState(null);
  const [videoTitle, setVideoTitle] = useState(null);
  const [mainChannelName, setmainChannelName] = useState("");
  const [VideoAllContent, setVideoAllContent] = useState("");



  const videoid = slug?.split("-").pop();


  // const { videoid, username } = useParams();
  useEffect(() => {
    const getData = async () => {
      const { data } = await Api.getMovieInfo(username, videoid);
      // console.log("ppppppppppdata", data)
       setVideoAllContent(data)
      const isSubchannel = data?.channelType === "Subchannels";
      setCategoryId(data?.channel?.name)
      setVideoTitle(data?.title)
      setmainChannelName(data?.channel?.parentChannel?.name)
      setChannelType(data?.channelType)
      setChannelID(isSubchannel ? data?.channel?.parentChannel : data?.channel?._id);
      setSubChannelID(isSubchannel ? data?.channel?._id : null);

      setvediocategoryLogo(isSubchannel ? data?.channel?.logo?.url : data?.channel?.logo?.url)
    };
    getData();
  }, [videoid]);
  // const { query } = useRouter();
  // const videoUrl = query.videoUrl ? decodeURIComponent(query.videoUrl) : null;
  // console.log("showid, category", showid, category, videoUrl)
  const array = [1, 2, 3, 4, 5, 6, 7, 8, 9]
  // const array = [1, 2]

  console.log("title", videoTitle)




  const { token } = isAutheticated()


  const intervalId = window.setInterval(function () {
    if (!adVideo) {
      const video = document.getElementById("player");
      if (video) {
        const isVideoPlaying =
          video.currentTime > 0 &&
          !video.paused &&
          !video.ended &&
          video.readyState > 2;

        if (isVideoPlaying) {
          for (let i = 0; i < studioData?.items?.length; i++) {
            const currentItem = studioData?.items[i];

            // console.log("Current Item:", currentItem);
            // console.log("Current Time:", currentItem?.current_time);
            // console.log("Video Time:", ~~video.currentTime);

            // Check if the video ID aligns
            if (currentItem?.videoId?.toString() === videoid) {
              const isExactTimeMatch = currentItem?.current_time == ~~video.currentTime;
              const isThroughoutAt30Sec =
                currentItem?.duration === "throughout" && ~~video.currentTime === 5;

              if (isExactTimeMatch || isThroughoutAt30Sec) {
                // console.log("Matching Item Found:", currentItem);

                if (currentItem?.type === "video" && currentItem?.CTA === "Insert Ad Video") {
                  setAdVideo(currentItem);
                  setResumeTime(Number(currentItem?.current_time) + 1);
                } else if (
                  (currentItem?.type === "internal" || currentItem?.type === "external") &&
                  currentItem?.CTA
                ) {
                  // console.log("Current Product:", currentItem);
                  setCurrentProduct({
                    duration: currentItem?.duration,
                    type: currentItem?.type,
                    productId: currentItem?._id,
                    url: currentItem?.url,
                    ProductThumbnail_Url: currentItem?.url || currentItem?.extProductThumbnail_Url,
                    externalProductUrl: currentItem?.extProduct_url || "",
                    extProduct_Name: currentItem?.extProduct_Name || "",
                    extProduct_Description: currentItem?.extProduct_Description || "",
                    extProduct_Price: currentItem?.extProduct_Price || "",
                    product: currentItem?.product,
                    CTA: currentItem?.CTA,
                    show_Button_Name: currentItem?.show_Button_Name,
                    qr_code: currentItem?.qr_code,
                  });

                  // Handle the popup logic for "throughout"
                  if (currentItem?.duration === "throughout") {
                    let isPopupVisible = false; // Flag to track popup visibility
                    let popupInterval; // Store the interval ID

                    const togglePopup = () => {
                      if (isPopupVisible) {
                        handleClose(); // Hide the popup
                        setTimeout(() => {
                          handleShowPopUp(); // Show the popup after 5 seconds
                          isPopupVisible = true;
                        }, 5000); // 5 seconds delay
                      } else {
                        handleShowPopUp(); // Show the popup
                        isPopupVisible = true;
                        setTimeout(() => {
                          handleClose(); // Hide the popup after 30 seconds
                          isPopupVisible = false;
                        }, 30000); // 30 seconds delay
                      }
                    };

                    // Clear any existing interval to prevent multiple timers
                    clearInterval(popupInterval);

                    // Start the interval with an initial show
                    handleShowPopUp(); // Initial show
                    isPopupVisible = true;

                    // Alternate between show (30 sec) and hide (5 sec)
                    popupInterval = setInterval(() => {
                      togglePopup();
                    }, 35000); // Total cycle duration (30 sec + 5 sec)

                    // Clean up the interval on unmount or when conditions change
                    return () => clearInterval(popupInterval);
                  }

                  setToast(true);
                }
              }
            }
          }
        }


      }
    }
  }, 1000);




  useEffect(() => {
    return () => {
      clearInterval(intervalId)
    }
  })




  const handleClose = () => {
    setToast(false);
  };
  const handleShowPopUp = () => {
    setToast(true);
  };

  window.onbeforeunload = function (e) {
    pouseHander();
    e.preventDefault();
    e.returnValue = ''; // Ensures confirmation dialog in some browsers
  };

  const pouseHander = async () => {
    if (!adVideo) {
      const video = document.getElementById("player");
      await Api.postMovieInfo({
        videoid: videoid,
        timeid: video.currentTime,
      });
    }
  };

  // console.log("cccccccccccccccc", `${API}/api/video-bandwidth`)
  useEffect(() => {
    const getStudio = async (videoId) => {
      try {
        const response = await axios({
          url: `${api}/api/studio/${videoId}/get_studio`,
          headers: {
            "Access-Control-Allow-Origin": "*",
            // Authorization: `Bearer ${localStorage.getItem("id_token")}`,
            Authorization: `Bearer ${token}`,
          },
        });
        // console.log("lllllllllllllll", response.data.data);
        setStudioData(response.data.data)
      } catch (err) {
        // console.log(err);
      }
      // setStudioData(res?.data)
    }
    getStudio(videoid)
  }, [videoid, token])

  function pauseVid() {
    const video = document.getElementById("player");
    video.pause();
    getCart();
  }

  const addToCart = async () => {
    setLoading(true)
    const req_quantity = 1
    const productId = currentProduct.product._id
    try {
      const data = await Api.addToCart(username, productId, req_quantity);
      setLoading(false)
      // console.log(data);
    } catch (e) {
      setLoading(false)
    }
    getCart()
    let closeCanvas = document.getElementById('shopOnDeviceClose');
    closeCanvas.click();
    setShowCart(true)
    let timeout = setTimeout(function () {
      setShowCart(false)
    }, 15000)

  }

  const AdVideoEnd = () => {
    setAdVideo(false)
  }


  const history = useHistory();
  // const handleVideoEnd = () => {
  //   // Redirect to the desired page after video ends
  //   history.push(`/view/${videoid}`);
  // };
  //share  button
  const handleShare = async () => {
    // Construct the dynamic URL based on the showid and videoid
    const shareUrl = `${window.location.origin}/${slug}/play?v=${videoUrl}`;

    const shareData = {
      // Optional: Add title or text as needed
      // title: movie?.title || "Check out this movie!",
      // text: `Watch ${movie?.title} on our platform!`,
      url: shareUrl, // Dynamic URL
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.error("Error sharing the link:", err);
        toastWarning("Failed to share the link.");
      }
    } else {
      // Fallback: copy the URL to the clipboard if native share isn't available
      navigator.clipboard.writeText(shareData.url);
      toastSuccess("Movie link copied to clipboard!");
    }
  };

  const videoRef = useRef(null); // Video reference
  const watchTimeRef = useRef(0); // Stores watch time

  const [loadedData, setLoadedData] = useState(0);
  const [videoDuration, setVideoDuration] = useState(0);
  const [watchTime, setWatchTime] = useState(0); // Actual watch time

  // Capture total video duration
  const handleLoadedMetadata = (event) => {
    setVideoDuration(event.target.duration);
    watchTimeRef.current = 0; // Reset watch time
  };

  const watchedSeconds = useRef(new Set()); // Store unique seconds

  const handleTimeUpdate = () => {
    if (videoRef.current) {
      let currentTime = Math.floor(videoRef.current.currentTime);

      // Add current second to the Set
      watchedSeconds.current.add(currentTime);
      // console.log("⏳ Current Time:", watchedSeconds.current.size);
      // Update state with total watched seconds
      setWatchTime(watchedSeconds.current.size);
    }
  };
  // Track video playback time
  // const handleTimeUpdate = (e) => {
  //   if (videoRef.current) {
  //     let currentTime = Math.floor(videoRef.current.currentTime);
  //     console.log("⏳ Current Time:", currentTime);

  //     if (currentTime > watchTimeRef.current) {
  //       watchTimeRef.current = currentTime;  // Store latest watch time
  //       setWatchTime(currentTime); // Also update state
  //     }
  //   }
  // };
  // Track data loaded during playback
  const handleProgress = (event) => {
    if (event.target.buffered.length > 0) {
      let bufferedEnd = event.target.buffered.end(0);
      let estimatedBytesLoaded = (bufferedEnd / event.target.duration) *
        event.target.videoWidth * event.target.videoHeight * 0.07;

      setLoadedData((prev) => prev + estimatedBytesLoaded);
    }
  };


  // console.log("watchTime", watchTime)
  // console.log("loadedData", loadedData)


  // Function to send bandwidth & watch time data
  const handleVideoEnd = async () => {
    const finalWatchTime = watchTimeRef.current; // Get latest watch time
    // console.log("🎯 Watch Time Captured:", watchedSeconds.current.size);

    try {
      if (watchTime > 0) {
        await axios.post(`${API}/api/video-watch`, {
          videoId: videoid,
          channelId: channelID,
          subChannelId: subchannellID,
          watchTime: watchedSeconds.current.size,
        });
        // console.log("✅ Video watch data sent successfully!");
      }

      if (loadedData > 0) {
        await axios.post(`${API}/api/video-bandwidth`, {
          bandwidth: loadedData,
          channelId: channelID,
          subChannelId: subchannellID,
        });
        // console.log("✅ Bandwidth data sent successfully!");
      }
    } catch (error) {
      console.error("❌ Error sending video data:", error);
    }

    // history.push(`/view/${videoid}`);
    history.goBack();
  };

  // Call API when back button is clicked
  // useEffect(() => {
  //   const unlisten = history.listen((location, action) => {
  //     if (action === "POP") {
  //       handleVideoEnd();
  //     }
  //   });

  //   return () => unlisten();
  // }, [history]);

  useEffect(() => {
    const handleBackOrUnload = () => {
      handleVideoEnd();
    };

    window.addEventListener("popstate", handleBackOrUnload);
    window.addEventListener("beforeunload", handleBackOrUnload);

    return () => {
      window.removeEventListener("popstate", handleBackOrUnload);
      window.removeEventListener("beforeunload", handleBackOrUnload);
    };
  }, []);



  const [isFullscreen, setIsFullscreen] = useState(false);

  const enterFullScreen = () => {
    const wrapper = document.getElementById("video-wrapper");
    if (wrapper.requestFullscreen) {
      wrapper.requestFullscreen();
    } else if (wrapper.webkitRequestFullscreen) {
      wrapper.webkitRequestFullscreen();
    } else if (wrapper.msRequestFullscreen) {
      wrapper.msRequestFullscreen();
    }
  };
  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  };
  useEffect(() => {
    const handleFullscreenChange = () => {
      const fsElement =
        document.fullscreenElement || document.webkitFullscreenElement;
      setIsFullscreen(!!fsElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
    };
  }, []);
  // const slugify = (text = "", id = "") =>
  //   `${text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}/channel/${text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`;

  // console.log('hiii', categoryId)

  const slugify = (mainChannelName = "", text = "") => {
    const textSlug = text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");

    if (mainChannelName) {
      const mainSlug = mainChannelName
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");
      return `${mainSlug}/channel/${textSlug}`;
    } else {
      return `net_channel/${textSlug}`;
    }
  };




  // let navigateUrl;

  // if (channelType === "Subchannels") {
  //   // if (!mainChannelName) {
  //   //   throw new Error("mainChannelName is required for Subchannels");
  //   // }
  //   navigateUrl = slugify(mainChannelName, categoryId);
  // } else if (categoryId) {
  //   navigateUrl = slugify("", categoryId); // reuse slugify for consistency
  // } else {
  //   navigateUrl = ""; // or a default fallback URL
  // }
let navigateUrl;
  if (channelType === "SoComAdvisor") {
    // navigateUrl = slugify(`apex_channel/${movie?.channel?.advisor_Name_Slug}`);
    const advisorSlug = VideoAllContent?.channel?.advisor_Name_Slug || null
    navigateUrl = `apex_channel/${advisorSlug}`;

  }
  else if (channelType === "Subchannels") {
    // if (!mainChannelName) {
    //   throw new Error("mainChannelName is required for Subchannels");
    // }
    navigateUrl = slugify(mainChannelName, categoryId);
  } else if (categoryId) {
    navigateUrl = slugify("", categoryId); // reuse slugify for consistency
  } else {
    navigateUrl = ""; // or a default fallback URL
  }





  return (
    <>
      <Helmet>
        {/* Title */}
        <title>
          {videoTitle ? `${videoTitle} - Watch Now` : "Watch Product Videos"}
        </title>

        {/* Meta Description */}
        <meta
          name="description"
          content={
            videoTitle
              ? `Watch "${videoTitle}" – engaging product video content available anytime, anywhere.`
              : "Explore engaging product videos and more."
          }
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content={videoTitle ? `${videoTitle}, Product Video, Streaming, Content` : "Product Video, Streaming, Content"}
        />

        {/* Open Graph for social sharing */}
        <meta property="og:title" content={videoTitle ? `${videoTitle} - Watch Now` : "Watch Product Videos"} />
        <meta
          property="og:description"
          content={
            videoTitle
              ? `Discover and watch "${videoTitle}" – stream instantly.`
              : "Watch product videos and discover more engaging content."
          }
        />
        <meta property="og:type" content="video.other" />
        <meta property="og:site_name" content="SoCom" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={videoTitle ? `${videoTitle} - Watch Now` : "Watch Product Videos"} />
        <meta
          name="twitter:description"
          content={
            videoTitle
              ? `Enjoy "${videoTitle}" – watch instantly and explore more content.`
              : "Explore and enjoy engaging product videos."
          }
        />
      </Helmet>

      <NavBar
        categoryLogo={vediocategoryLogo}
        categoryId={navigateUrl}
      />
      <div>
        <div id="video-wrapper"
          style={{
            position: "relative",
            width: "100%",
            height: "90vh",
            overflow: "hidden",
            backgroundColor: "#000", // Dark background for a cinematic effect
          }}
        >
          {/* Video Player */}
          {adVideo ? (
            <video
              onEnded={() => AdVideoEnd()}
              id="AdPlayer"
              src={adVideo.url}
              style={{
                width: "100%", // Ensures the video spans the width of its container
                height: "100%", // Ensures the video spans the height of its container
                objectFit: "contain", // Ensures the entire video is visible
                position: "absolute",
              }}
              autoPlay={true}
            ></video>
          ) : (
            <video
              id="player"
              onPause={pouseHander}
              ref={videoRef}
              
              onEnded={handleVideoEnd}
              onLoadedMetadata={handleLoadedMetadata}
              onProgress={handleProgress}
              onTimeUpdate={handleTimeUpdate}  // ⬅️ Call function here

              src={`${videoUrl}#t=${resumeTime}`}
              style={{
                width: "100%", // Ensures the video spans the width of its container
                height: "90vh",
                top: 0,
                left: 0,
                height: "100%", // Ensures the video spans the height of its container
                objectFit: "contain", // Ensures the entire video is visible
                position: "absolute",
                zIndex: 1,

              }}


              controls
              autoPlay={true}
            ></video>
          )}

          <div
            id="wrapper"
            style={{
              position: "absolute",
              bottom: "2rem",
              // right: "1rem",
              zIndex: 9999, // Make sure it's above the video
              // width: "90%",
              // maxWidth: "600px",

            }}
          >
            {toast && (
              <ToastProduct
                product={currentProduct}
                 VideoAllContent={VideoAllContent}
                                 sourceUrl={sourceUrl}

                handleClose={handleClose}
                pauseVid={pauseVid}
                handleShowPopUp={handleShowPopUp}
              />
            )}
            {/* <div className="mt-3 text-center">
              {!isFullscreen ? (
                <button onClick={enterFullScreen} className="btn btn-primary">
                  <FaExpand />
                </button>
              ) : (
                <button onClick={exitFullScreen} className="btn btn-danger">
                  <FaCompress />
                </button>
              )}
            </div> */}

          </div>





          {/* Top Right Control Buttons */}
          {/* <div
            className="control-buttons text-light position-absolute d-flex flex-column align-items-center"
            style={{
              top: "1rem",
              right: "2rem",
              zIndex: "10",
            }}
          >
            <button
              onClick={pauseVid}
              className="btn cart-btn mb-2"
              style={{
                backgroundColor: "#FFC107", // Bright yellow for the button
                borderRadius: "50%",
                boxShadow: "0px 4px 6px rgba(0,0,0,0.3)",
              }}
            >
              <Link to="/checkout" ><FaCartPlus size="1.5rem" color="#000" /></Link>


            </button>

            <button
              onClick={handleShare}
              className="btn share-btn"
              style={{
                backgroundColor: "#17A2B8",
                borderRadius: "50%",
                boxShadow: "0px 4px 6px rgba(0,0,0,0.3)",
              }}
            >
              <FiShare2 size="1.5rem" color="#fff" />
            </button>
          </div> */}

          {/* Toast Notification */}


          {/* CSS Styling */}
          <style jsx>{`
    /* Base styles */
    .control-buttons .btn {
      width: 3rem;
      height: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: transform 0.2s ease-in-out, box-shadow 0.2s;
    }
    .control-buttons .btn:hover {
      transform: scale(1.1); /* Slight zoom on hover */
      box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.5); /* Elevated shadow */
    }

    /* Responsive adjustments */
    @media (max-width: 1200px) {
      .control-buttons {
        top: 1.5rem;
        right: 1.5rem;
      }
      .control-buttons .btn {
        width: 2.8rem;
        height: 2.8rem;
      }
    }

    @media (max-width: 992px) {
      .control-buttons {
        top: 2rem;
        right: 1rem;
      }
      .control-buttons .btn {
        width: 2.5rem;
        height: 2.5rem;
      }
    }

    @media (max-width: 768px) {
      .control-buttons {
        top: 2.5rem;
        right: 0.8rem;
      }
      .control-buttons .btn {
        width: 2.2rem;
        height: 2.2rem;
      }
    }

    @media (max-width: 576px) {
      .control-buttons {
        top: 3rem;
        right: 0.5rem;
      }
      .control-buttons .btn {
        width: 2rem;
        height: 2rem;
      }
    }
  `}</style>
        </div >



        <div className="offcanvas offcanvas-end" style={{ backgroundColor: "black" }} tabindex="-1" id="shopOnDevice" aria-labelledby="shopOnDevice">
          <div className="offcanvas-header">
            <button type="button" className="btn-close text-reset" style={{ backgroundColor: "white" }} id="shopOnDeviceClose" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="offcanvas-body">
            <div className="text-center">
              <img
                width="90%"
                style={{ height: "40vh" }}
                src={currentProduct?.product?.image}
                alt="product"
              />
            </div>
            <div className="text-white mx-4 mt-3">
              <h2>{currentProduct?.product?.title}</h2>
              <p>
                {currentProduct?.description}
              </p>
              <div>
                <h4>₹ {currentProduct?.product?.sale_price}</h4>
              </div>
              <button disabled={loading} className="w-100 mt-2 btn btn-outline-light btn-lg" onClick={addToCart}><FaCartPlus />&nbsp;&nbsp;<b>Add To Cart</b></button>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};
export default PlayMovie;
